/**
 * This component is for revive claim with deal id and duration
 * only job number with ignoreInvoice 1 can revive claim
 *
 */

import React, { useContext, useEffect, useState } from "react";
import {
  Box,
  Grid,
  TextField,
  IconButton,
  Button,
  CircularProgress,
  Snackbar,
  Alert,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
} from "@mui/material";
import { DataGrid, GridToolbarQuickFilter } from "@mui/x-data-grid";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import SearchIcon from "@mui/icons-material/Search";
import {
  claimsDealerAdTools,
  claimsDownload,
} from "../services/ClaimsServices";
import { AuthContext } from "../AuthContext";
import CustomNoRowsOverlay from "./gridNoRowOverLay";
import FlipCameraAndroidIcon from "@mui/icons-material/FlipCameraAndroid";

const columns = [
  {
    field: "jobNumber",
    headerName: "Job Number",
    width: 120,
    sortable: false,
    headerAlign: "center",
    align: "center",
  },
    {
    field: "invoiceId",
    headerName: "Invoice #",
    width: 120,
    sortable: false,
    headerAlign: "center",
    align: "center",
  },
  {
    field: "jbwAgreementId",
    headerName: "Agreement Id",
    width: 120,
    sortable: false,
    headerAlign: "center",
    align: "center",
  },
  {
    field: "customerName",
    headerName: "CustomerName",
    width: 120,
    sortable: false,
    headerAlign: "center",
    align: "center",
  },
  {
    field: "Address",
    headerName: "Address",
    width: 200,
    sortable: false,
    headerAlign: "center",
    align: "center",
  },
  {
    field: "jbwClaimId",
    headerName: "JBW Claim ID",
    width: 120,
    sortable: false,
    headerAlign: "center",
    align: "center",
  },
  {
    field: "claimAmount",
    headerName: "Amount",
    width: 120,
    sortable: false,
    headerAlign: "center",
    align: "center",
  },
  {
    field: "claimStatus",
    headerName: "Claim Status",
    width: 200,
    sortable: false,
    headerAlign: "center",
    align: "center",
  },
];

const claimDuration = [
  { id: 30, name: "30 Days" },
  { id: 60, name: "60 Days" },
  { id: 90, name: "90 Days" },
  { id: 1, name: "Custom" },
];

export const DownloadClaimsTool = () => {
  const { user } = useContext(AuthContext);
  const [searchText, setSearchText] = useState("");
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [rows, setRows] = useState([]);
  const [selectedIds, setSelectedIds] = useState([]);
  const [loading, setLoading] = useState(false);
  const [downloadSuccess, setDownloadSuccess] = useState(false);
  const [downloadError, setDownloadError] = useState(false);
  const [errors, setErrors] = useState({
    searchText: false,
    startDate: false,
    endDate: false,
    dateMismatch: false,
  });
  const [duration, setDuration] = useState(30);
  const [reviving,setReviving] = useState(false);

  const validateInputs = () => {
    const newErrors = {
      searchText: searchText.trim() === "",
      startDate: !startDate,
      endDate: !endDate,
      dateMismatch:
        startDate && endDate && dayjs(startDate).isAfter(dayjs(endDate)),
    };
    setErrors(newErrors);
    return !Object.values(newErrors).some(Boolean);
  };

  const handleSearch = async () => {
    if (!validateInputs()) return;
    setRows([]);
    setSelectedIds([]);
    setLoading(true);
    const resData = await claimsDownload(searchText, startDate, endDate);
    console.log("clamins download search result", resData);
    setRows(resData.data);
    setLoading(false);
  };

  const handleDownload = async () => {
    if (selectedIds.length === 0) {
      setDownloadError(true);
      return;
    }
    setReviving(true);
    const selectedRows = rows.filter((row) => selectedIds.includes(row.id));
    console.log("selected rows :", selectedRows);
    const rowIds = selectedRows.map((sr) => sr.id)?.toString();
    console.log("selected row ids :", rowIds);
    const result = await claimsDealerAdTools({
      claimids: rowIds,
      uid: user.name,
    });
    console.log("claimsDealerAdTools Result is :", result);
    if (result.data && result.data.affectedRows > 0) {
      await handleSearch();
      
      setDownloadSuccess(true);
    }
    setReviving(false);
  };

  const isSearchDisabled =
    loading ||
    searchText.trim() === "" ||
    !startDate ||
    !endDate ||
    (startDate && endDate && dayjs(startDate).isAfter(dayjs(endDate)));

  const handleDurationChange = (event) => {
    const value = event.target.value;
    console.log("selected duration :", value);
    setDuration(value);
  };

  const handleDurationDate = (duration) => {
    const today = new Date();
    const nextDate = new Date(today);
    nextDate.setDate(today.getDate() - duration);
    console.log(
      `duration is :${duration}   today : ${today
        .toISOString()
        .slice(0, 10)}   end date : ${nextDate.toISOString().slice(0, 10)}`
    );
    setEndDate(today.toISOString().slice(0, 10));
    setStartDate(nextDate.toISOString().slice(0, 10));
  };

  useEffect(() => {
    if (duration !== 1) {
      handleDurationDate(duration);
    } else {
      setStartDate(null);
      setEndDate(null);
    }
  }, [duration]);



  const QuickSearchToolbar = () => {
    return (
      <Box
        sx={{
          p: 0.5,
          pb: 0,
        }}
      >
        <GridToolbarQuickFilter />
      </Box>
    );
  };

  return (
    <>
      <Grid container spacing={2} alignItems="center">
        <Grid item xs={12} sm={3}>
          <TextField
            fullWidth
            label="Search Dealer"
            value={searchText}
            onChange={(e) => setSearchText(e.target.value)}
            error={errors.searchText}
            helperText={errors.searchText ? "Please enter Dealer" : ""}
            disabled={loading}
          />
        </Grid>
        <Grid item xs={12} sm={2}>
          <FormControl fullWidth>
            <InputLabel id="dct-select-label">Duration</InputLabel>
            <Select
              labelId="dct-select-label"
              id="dct-select"
              value={duration}
              label={duration}
              onChange={handleDurationChange}
            >
              {claimDuration.map((dt) => (
                <MenuItem key={dt.id} value={dt.id}>
                  {dt.name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>
        {duration === 1 && (
          <>
            <Grid item xs={12} sm={2}>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  label="Start Date"
                  value={startDate}
                  onChange={(newValue) => setStartDate(newValue)}
                  disabled={loading}
                  format="MM/DD/YYYY"
                  maxDate={new Date().toISOString().slice(0, 10)}
                  slotProps={{
                    textField: {
                      fullWidth: true,
                      error: errors.startDate || errors.dateMismatch,
                      helperText: errors.startDate
                        ? "Start date is required"
                        : errors.dateMismatch
                        ? "Start must be before or equal to End date"
                        : "",
                    },
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      variant="standard"
                      sx={{
                        "& .MuiOutlinedInput-root": {
                          height: "50px",
                        },
                        "& .MuiInputBase-input": {
                          height: "1.4375em",
                          padding: "5px 14px",
                        },
                      }}
                    />
                  )}
                />
              </LocalizationProvider>
            </Grid>
            <Grid item xs={12} sm={2}>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  label="End Date"
                  value={endDate}
                  onChange={(newValue) => setEndDate(newValue)}
                  disabled={loading}
                  minDate={startDate}
                  maxDate={new Date().toISOString().slice(0, 10)}
                  slotProps={{
                    textField: {
                      fullWidth: true,
                      error: errors.endDate || errors.dateMismatch,
                      helperText: errors.endDate
                        ? "End date is required"
                        : errors.dateMismatch
                        ? "End must be after or equal to Start date"
                        : "",
                    },
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      variant="standard"
                      sx={{
                        "& .MuiOutlinedInput-root": {
                          height: "50px",
                        },
                        "& .MuiInputBase-input": {
                          height: "1.4375em",
                          padding: "5px 14px",
                        },
                      }}
                    />
                  )}
                />
              </LocalizationProvider>
            </Grid>
          </>
        )}

        <Grid item xs={12} sm={1}>
          <IconButton
            color="primary"
            onClick={handleSearch}
            disabled={isSearchDisabled}
            sx={{ border: "1px solid #ccc" }}
          >
            {loading ? (
              <CircularProgress size={20} color="warning" />
            ) : (
              <SearchIcon color="secondary" />
            )}
          </IconButton>
        </Grid>
        <Box sx={{ flexGrow: 1 }} />
        <Grid item xs={12} sm={2}>
          <Button
            variant="outlined"
            onClick={handleDownload}
            disabled={!selectedIds.length>0 || loading}
             startIcon={reviving ?<CircularProgress size={20} color="warning" /> :<FlipCameraAndroidIcon fontSize="medium" />}
          >
            Revive Claim
          </Button>
        </Grid>
      </Grid>

      <Box sx={{ my: 2, height: 400 }}>
        <DataGrid
          rows={rows}
          columns={columns}
          checkboxSelection
          checkboxSelectionVisibleOnly={true}
          disableColumnFilter={true}
          disableColumnMenu={true}
          isRowSelectable={(params) => params.row.ignoreInvoice === 1}
          loading={loading}
          onRowSelectionModelChange={(ids) => setSelectedIds(ids)}
          rowSelectionModel={selectedIds}
          slots={{
            noRowsOverlay: CustomNoRowsOverlay,
            toolbar: QuickSearchToolbar,
          }}
        />
      </Box>

      <Snackbar
        open={downloadSuccess}
        autoHideDuration={3000}
        onClose={() => setDownloadSuccess(false)}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      >
        <Alert
          severity="success"
          sx={{ width: "100%" }}
          onClose={() => setDownloadSuccess(false)}
        >
          Selected Claim Revived successfully!
        </Alert>
      </Snackbar>

      <Snackbar
        open={downloadError}
        autoHideDuration={3000}
        onClose={() => setDownloadError(false)}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      >
        <Alert
          severity="error"
          sx={{ width: "100%" }}
          onClose={() => setDownloadError(false)}
        >
          Please select at least one Claim to Revive.
        </Alert>
      </Snackbar>
    </>
  );
};
